import { isValidCssColor, isValidHexColor, resolveCSSVariable, } from '@thoughtspot/radiant-react/widgets/color/color-utils';
import { Icon, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import cx from 'classnames';
import { hexToCSSFilter } from 'hex-to-css-filter';
import React from 'react';
import styles from '../../styles/kpi.module.scss';
export const ArrowIcon = ({ iconId, color, ariaLabel, isKPIWithAnomalyV2Enabled = false, }) => {
    const resolvedColor = color ? resolveCSSVariable(color) : color;
    const isValidHex = isValidHexColor(resolvedColor);
    const isValidCSS = isValidCssColor(resolvedColor);
    const filterCSS = (() => {
        if (!resolvedColor)
            return '#ffffff';
        if (isValidHex)
            return hexToCSSFilter(resolvedColor).filter.slice(0, -1);
        if (isValidCSS)
            return resolvedColor;
        return '#ffffff';
    })();
    const iconStyle = (() => {
        if (!resolvedColor)
            return {};
        if (isValidHex) {
            return { filter: filterCSS };
        }
        if (isValidCSS) {
            return { fill: resolvedColor };
        }
        return {};
    })();
    if (isKPIWithAnomalyV2Enabled) {
        return (React.createElement(Icon, { style: iconStyle, size: IconSize.XSMALL, id: iconId, "aria-label": ariaLabel || '', className: styles.arrowIcon }));
    }
    return (React.createElement("div", { style: { filter: filterCSS }, className: cx({
            [styles.arrowUp]: iconId === IconID.ARROW_UP,
            [styles.arrowDown]: iconId === IconID.ARROW_DOWN,
        }), "aria-label": ariaLabel || '' }));
};
//# sourceMappingURL=ArrowIcon.js.map